// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { rfqConfirmationProductListStyles } from "@conklin/Overrides/Widgets/RfqConfirmation/RfqConfirmationProductList";
import { color, xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

rfqConfirmationProductListStyles.wrapper = {
    css: css`
        padding-top: 24px;
        margin-top: 24px;
        border-top: 1px solid ${color("common.border")};
    `,
};

rfqConfirmationProductListStyles.cartLinesList = {
    cardExpanded: {
        cartLineContainer: {
            notes: {
                css: css`
                    ${xScreen("lte", "md")} {
                        grid-row: 6 / 7;
                    }
                `,
            },
        },
    },
};
